import { render, staticRenderFns } from "./Dirigentes.vue?vue&type=template&id=502658e3"
import script from "./Dirigentes.vue?vue&type=script&lang=js"
export * from "./Dirigentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports